import { Injectable } from "@angular/core";
import { AsyncLocalStorage } from 'angular-async-local-storage';

@Injectable()
export class CustomStorage {
    
    constructor(protected localStorage:AsyncLocalStorage){
 
    }

    getItem(key){
        return this.localStorage.getItem(key);
    }
    
    setItem(key, value){
        return this.localStorage.setItem(key, value);
    }

    removeItem(key){
        return this.localStorage.removeItem(key);
    }
    emptyStorage(){
        this.localStorage.clear().subscribe(val=>console.log())

    }

}


// WEBPACK FOOTER //
// ./src/app/providers/Custom-storage.service.ts